import { defineMessages } from 'react-intl.macro';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CtaBtn, DangerAlert, WaitingAlert } from '@tmapy/style-guide';

import { QUERY_STATE } from '../../constants';

const msg = defineMessages({
  showNext: {
    id: 'loadNextItemsBar.showNext',
    defaultMessage: 'Zobrazit další',
  },
  loading: {
    id: 'loadNextItemsBar.loading',
    defaultMessage: 'Načítají se další záznamy...',
  },
  failed: {
    id: 'loadNextItemsBar.failed',
    defaultMessage: 'Další záznamy se nepovedlo načíst.',
  },
  count: {
    id: 'loadNextItemsBar.count',
    defaultMessage: 'Zobrazeno {count} záznamů z {total}.',
  },
});

interface LoadNextItemsBarProps {
  count: number;
  total: number;
  queryState: QUERY_STATE;
  onNextBtnClick(): void;
}

export const LoadNextItemsBar: React.FC<LoadNextItemsBarProps> = ({
  count,
  total = 0,
  queryState,
  onNextBtnClick,
}) => {
  return (
    <div className='sg-a-d-f sg-a-ai-c sg-u-hsl-2'>
      {count < total && (
        <CtaBtn isDisabled={queryState === QUERY_STATE.WAITING} onClick={onNextBtnClick}>
          <FormattedMessage {...msg.showNext} />
        </CtaBtn>
      )}
      {queryState === QUERY_STATE.WAITING && (
        <WaitingAlert>
          <FormattedMessage {...msg.loading} />
        </WaitingAlert>
      )}
      {queryState === QUERY_STATE.FAIL && (
        <DangerAlert>
          <FormattedMessage {...msg.failed} />
        </DangerAlert>
      )}
      <span className='sg-u-type-sml sg-u-c-body-darker'>
        <FormattedMessage {...msg.count} values={{ count, total }} />
      </span>
    </div>
  );
};
